module.exports = __webpack_public_path__ + "img/icon-alert-medium-outline.b8add9d7.svg";